export default __webpack_public_path__ + "static/media/consultant.d548b11e.jpg";